
import AbstractCounterIcon from '@/lib/components/Shared/AbstractCounterIcon.vue';
import { cartIconController } from '@/lib/components/Shared/CartIcon.controller';
import { defineComponent } from 'vue';
import { useController } from '@/domain/services/Composer';
import { CounterProps, CounterView } from '@/lib/components/Shared/Counter.composable';

export default defineComponent<CounterProps, CounterView>({
	extends: AbstractCounterIcon,
	setup: useController(cartIconController, 'CartIconController') as () => CounterView,
});
